import Immutable from 'immutable';
import { gofor } from '@fiverr-private/futile/lib/gofor';
import { URI } from '@fiverr-private/futile/lib/url/URI';
import pathfinder from '@fiverr-private/pathfinder';

const UPDATE_REVIEWS = 'reviews/update_reviews';

const PAGE_SIZE = 5;

const AS_SELLER_FALSE = false;

const initialState = Immutable.fromJS({});

export default function(state = initialState, action = {}) {

    switch (action.type) {
        case UPDATE_REVIEWS:
            if (state.get('is_double_blind_format')) {
                const newReviewsList = action.isFilter ? action.list.reviews : state.get('reviews').push(...action.list.reviews).toJS();
                state = state.update('reviews', () => Immutable.fromJS(newReviewsList));
            }
            else {
                const newStarsList = action.isFilter ? action.list.stars : state.get('stars').push(...action.list.stars).toJS();
                state = state.update('stars', () => Immutable.fromJS(newStarsList));
            }

            state = state.update('has_more_pages', () => action.list.has_more_pages);
            state = state.update('type', () => action.filterType);
            return state;
        default:
            return state;
    }
}

export function updateReviews(list, filterType, isFilter) {
    return {
        type: UPDATE_REVIEWS,
        filterType,
        isFilter,
        list
    };
}

/** Load More & Order By reviews */
export function fetchReviews(event, type, lastReview, pathFinderConfig) {
    return function(dispatch, state) {

        const isFilter = event.target.tagName === 'SELECT',
            filterType = (isFilter) ? event.target.value : type,
            gigId = state().get('gig_id') || state().get('gigId'),
            asSeller = state().get('reviews_as_seller') || AS_SELLER_FALSE,
            isDoubleBlindFormat = state().get('is_double_blind_format');

        let idType = 'user',
            id = state().get('user_id') || state().get('userId'),
            url;

        if (gigId) {
            idType = 'gig';
            id = gigId;
        }

        if (pathFinderConfig){
            const { path, params } = pathFinderConfig.toObject();
            url = new URI(`${pathfinder(path, params.toObject())}`);
        } else {
            url = new URI('/ratings/index').addParams({
                [`${idType}_id`]: id,
                page_size: PAGE_SIZE
            });
        }

        if (isDoubleBlindFormat) {
            url.addParams({
                is_double_blind_format: `${isDoubleBlindFormat}`
            });

            if (idType === 'user') {
                url.addParams({
                    as_seller: `${asSeller}`
                });
            }
        }

        if (!isFilter && lastReview) {
            url.addParams({
                last_star_rating_id: lastReview
            });
        }

        if (filterType) {
            url.addParams({
                type: filterType
            });
        }

        gofor(url.toString())
            .then((response) => {
                if (!response.ok) { throw new Error(response.statusText); }

                return response.json();
            })
            .then((res) => {
                dispatch(updateReviews(res, filterType, isFilter));
            });
    };
}



// WEBPACK FOOTER //
// ./src/reviews/module/index.js